import PropTypes from "prop-types"
import React from "react"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"
import * as css from "./ComparisonTable.module.css"

function ComparisonTable({
  label,
  heading,
  description,
  presetColumn = "Preset",
  competitorColumn = "Power BI",
  rows,
}) {
  return (
    <Section padding="light">
      <SimpleHeader
        label={label}
        title={heading}
        subtitle={description}
        dash="vertical"
        narrow="both"
      />
      <div className={css.tableWrapper}>
        <table className={css.table}>
          <thead>
            <tr>
              <th className={css.featureHeader}>Feature</th>
              <th className={css.presetHeader}>{presetColumn}</th>
              <th className={css.competitorHeader}>{competitorColumn}</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, index) => (
              <tr key={index} className={css.row}>
                <td className={css.feature}>{row.feature}</td>
                <td className={css.presetCell}>
                  {row.preset === true ? (
                    <span className={css.check}>✓</span>
                  ) : row.preset === false ? (
                    <span className={css.x}>✗</span>
                  ) : (
                    <span className={css.note}>{row.preset}</span>
                  )}
                  {row.presetNote && (
                    <span className={css.cellNote}>{row.presetNote}</span>
                  )}
                </td>
                <td className={css.competitorCell}>
                  {row.competitor === true ? (
                    <span className={css.check}>✓</span>
                  ) : row.competitor === false ? (
                    <span className={css.x}>✗</span>
                  ) : (
                    <span className={css.note}>{row.competitor}</span>
                  )}
                  {row.competitorNote && (
                    <span className={css.cellNote}>{row.competitorNote}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  )
}

ComparisonTable.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  presetColumn: PropTypes.string,
  competitorColumn: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      feature: PropTypes.string.isRequired,
      preset: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      presetNote: PropTypes.string,
      competitor: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      competitorNote: PropTypes.string,
    })
  ),
}

export default ComparisonTable
